// extracted by mini-css-extract-plugin
export default {"title":"TypePost_title__d2n2e","typePost":"TypePost_typePost__Un4b2"};